/** Eastern time stamp matching legacy sheet style, e.g. "7.11.26 at 4:02 PM". */
export function formatEasternLedgerTime(date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date);

  const pick = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? '';

  return `${pick('month')}.${pick('day')}.${pick('year')} at ${pick('hour')}:${pick('minute')} ${pick('dayPeriod').toUpperCase()}`;
}
